//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/popup'
import 'devextreme/ui/progress_bar'
import 'devextreme/ui/load_indicator'

//#endregion

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { CreateRelatedItemsController } from './create-related-items.controller'

//#region Asset Imports

import './create-related-items.scss'
import * as TEMPLATE from './create-related-items.tpl.html'

//#endregion

// #region Consts

export const COMPONENT_NAME: string = 'createRelatedItems'

// #endregion

// #region Setup

/**
 * This component allows to create new items based on other items.
 * For example if you want to create OpTask objects based on OpLocation objects you can use this component.
 * */
export class CreateRelatedItemsComponent
{
    controller = [
        USER_SESSION_SERVICE_NAME,
        (
            userSession: UserSessionService
        ) => {
            return new CreateRelatedItemsController(userSession)
        }
    ]

    bindings = {
        id: '<',
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}

// #endregion